import api from '../../plugins/api';

const getLeadCard = (params) => {
  return api.get('/api/crm/leads/getLeadCard', params);
};

export default getLeadCard;
